import { ofType } from 'redux-observable';
import { catchError, switchMap } from 'rxjs/operators';
import { from, of } from 'rxjs';


import { Epic } from 'models/meta/epic';
import { addCompanyIdToQueryParams } from 'store/common.helpers';

import { FETCH_TRANSACTIONS_LIST } from './actions.types';
import { fetchTransactionsListFailure, fetchTransactionsListSuccess } from './actions';

export const onFetchTransactionsList: Epic = (action$, state$, { transactions }) => action$.pipe(
    ofType(FETCH_TRANSACTIONS_LIST),
    switchMap(({ payload: { locationPathname, queryParams } }) => from(transactions.getAllTransactions(addCompanyIdToQueryParams({ state$, queryParams })))
        .pipe(
            switchMap((response) => of(fetchTransactionsListSuccess({
                items: response.data.rows,
                totalCount: response?.data.count,
                locationPathname,
            }))),
            catchError(() => of(fetchTransactionsListFailure(locationPathname))),
        )),
);


export default [
    onFetchTransactionsList,
];

